export const getMonday = (date) => {
  const d = new Date(date);
  const day = d.getDay() || 7;
  d.setDate(d.getDate() - day + 1);
  return d;
};

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const formatFechaLarga = (date) =>
  date.toLocaleDateString("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric"
  });

export const formatSemana = (inicio) => {
  const fin = addDays(inicio, 6);
  return `${inicio.toLocaleDateString("es-ES",{day:"numeric",month:"short"})}
   - ${fin.toLocaleDateString("es-ES",{day:"numeric",month:"short",year:"numeric"})}`;
};

